import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpEvent, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError, Subject} from 'rxjs';
import {Router} from '@angular/router';

import { User } from '../components/users/user';
import { environment} from '../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from './user.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router,
    private snackBar: MatSnackBar, private userService: UserService) { }

  private subject = new Subject<any>();

     authUpdate() {
        this.subject.next();
    }

    getAuth(): Observable<any> {
        return this.subject.asObservable();
    }


  public get user(): User {

    if (this._user != null) {
      return this._user;
    } else if (localStorage.getItem('user') != null) {
      return JSON.parse(localStorage.getItem('user')) as User;
    }
    return null;
  }
  public set user(value: User) {
    this._user = value;
  }

  public get token(): string {
    if (this._token != null) {
      return this._token;
    } else if (localStorage.getItem('token') != null) {
      return localStorage.getItem('token');
    }
    return null;  }

  public set token(value: string) {
    this._token = value;
  }

  public get refreshToken(): string {
    if (this._refreshToken != null) {
      return this._refreshToken;
    } else if (localStorage.getItem('refreshToken') != null) {
      return localStorage.getItem('refreshToken');
    }
    return null;  }

  public set refreshToken(value: string) {
    this._refreshToken = value;
  }
  // tslint:disable-next-line:variable-name
  private _user: User;
  // tslint:disable-next-line:variable-name
  private _token: string;

  private urlEndPoint = environment.endPoint + '/oauth/token';
  // tslint:disable-next-line:variable-name
  private _refreshToken: string;

  private static payload(accessToken: string): any {
    if (accessToken != null) {
      return JSON.parse(atob(accessToken.split('.')[1]));
    } else {
      return null;
    }
  }

  static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new HttpErrorResponse(error);
  }

  login(username: string, password: string): Observable<User> {
    const credentials = btoa('angularapp' + ':' + '12345');
    const httpHeaders = new HttpHeaders({ 'Content-type': 'application/x-www-form-urlencoded',
                                          Authorization: 'Basic ' + credentials});

    const params = new URLSearchParams();
    params.set('grant_type', 'password');
    params.set('username', username);
    params.set('password', password);
    return this.http.post<User>(this.urlEndPoint, params.toString(), {headers: httpHeaders})
        .pipe(
            map(userData => {
              // login successful if there's a jwt token in the response
              this.saveToken(userData.access_token, userData.refresh_token);
              this.saveUser(userData.access_token);
              return userData;
            }),
            catchError(this.handleError)
        );
  }
  // this.auth.saveUser(response.access_token);
  // this.auth.saveToken(response.access_token, response.refresh_token);
  logout(): void {
    const credentials = btoa('angularapp' + ':' + '12345');
    const httpHeaders = new HttpHeaders({Authorization: 'Basic ' + credentials});
    
    this._user = null;
    this._token = null;
    localStorage.clear();
    this.authUpdate();
    this.router.navigate(['/login']);
      
   
  }

  public saveUser(accessToken: string): void {
    const payload = AuthService.payload(accessToken);
    this._user = new User();

    this.userService.setUser(payload);

    this._user.username = payload.user_name;
    this._user.authorities = payload.authorities;
    this._user.laboratoryId = payload.laboratory_id;
    this._user.groups["report"] = payload.reportGroups;
    this._user.groups["order-entry"] = payload.orderEntryGroups;
    this._user.groups["phlebotomy"] = payload.phlebotomyGroups;
    this._user.groups["configuration"] = payload.configurationGroups;


    // DEFINIR BIEN LOS DATOS DEL USUARIO!

    localStorage.setItem('user', JSON.stringify(this._user));
  }

  public saveToken(accessToken: string, refreshToken: string): void {
    this._token = accessToken;
    localStorage.setItem('token', accessToken);
    localStorage.setItem('refreshToken', accessToken);

  }

  public hasAuthority(authority: string): boolean {
    if(this.user){
      if (this.user.authorities.includes(authority)) {
        return true;
      }
    }    
    return false;
  }

  public isAuthenticated(): boolean {
    const payload = AuthService.payload(this.token);
    return payload != null && payload.user_name && payload.user_name.length > 0;
  }
  public isTokenExpired(): boolean {
    const token = this.token;
    const payload = AuthService.payload(token);
    const now = new Date().getTime() / 1000; // en segundos
    if (payload.exp < now) {
      return true;
    }
    return false;
  }

  handleError(error: HttpErrorResponse) {
    //alert("Credenciales incorrectas");
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(error);
  }
}
